import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "complete-new-password-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Complete New Password", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "You need to set your own password.", -1)

import CompleteNewPassword from '@/components/auth/CompleteNewPassword.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CompleteNewPassword',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(CompleteNewPassword)
  ]))
}
}

})